import api from './api';

export type Rol = 'Admin' | 'Usuario';

export interface UsuarioAdmin {
  id: number;
  nombre?: string;
  apellido?: string;
  email?: string;
  rut?: string;
  rol: Rol | 'SuperAdmin';
  activo: boolean;
  fechaCreacion: string;
}

export interface CreateUsuarioDto {
  nombre?: string;
  apellido?: string;
  email?: string;
  rut?: string;
  rol: Rol;
  password?: string;
}

export interface UpdateUsuarioDto {
  nombre?: string;
  apellido?: string;
  email?: string;
  rut?: string;
  rol: Rol;
  activo: boolean;
}

export const usuarioService = {
  // ---- Usuarios globales por auth (sin tenant, o admin gestionando su propio usuario) ----
  async getUsuariosAuth(): Promise<UsuarioAdmin[]> {
    const { data } = await api.get('/auth/usuarios');
    return data;
  },

  async createUsuarioAuth(dto: CreateUsuarioDto): Promise<UsuarioAdmin> {
    const { data } = await api.post('/auth/register', dto);
    return data;
  },

  async updateUsuarioAuth(id: number, dto: UpdateUsuarioDto): Promise<UsuarioAdmin> {
    const { data } = await api.put(`/auth/usuarios/${id}`, dto);
    return data;
  },

  async deleteUsuarioAuth(id: number): Promise<void> {
    await api.delete(`/auth/usuarios/${id}`);
  },

  // ---- Miembros de la propia empresa (Admin dentro de su tenant) ----
  async getMiembrosEmpresa(): Promise<UsuarioAdmin[]> {
    const { data } = await api.get('/Empresas/miembros');
    return data;
  },

  async addMiembroEmpresa(usuarioId: number): Promise<void> {
    await api.post('/Empresas/miembros', { usuarioId });
  },

  async removeMiembroEmpresa(id: number): Promise<void> {
    await api.delete(`/Empresas/miembros/${id}`);
  },

  // ---- Usuarios de una empresa específica (SuperAdmin gestionando cualquier tenant) ----
  async getUsuariosEmpresa(empresaId: number): Promise<UsuarioAdmin[]> {
    const { data } = await api.get(`/SuperAdmin/empresas/${empresaId}/usuarios`);
    return data;
  },

  async createUsuarioEmpresa(empresaId: number, dto: CreateUsuarioDto): Promise<UsuarioAdmin> {
    const { data } = await api.post(`/SuperAdmin/empresas/${empresaId}/usuarios`, dto);
    return data;
  },

  async updateUsuarioEmpresa(empresaId: number, id: number, dto: UpdateUsuarioDto): Promise<UsuarioAdmin> {
    const { data } = await api.put(`/SuperAdmin/empresas/${empresaId}/usuarios/${id}`, dto);
    return data;
  },

  async deleteUsuarioEmpresa(empresaId: number, id: number): Promise<void> {
    await api.delete(`/SuperAdmin/empresas/${empresaId}/usuarios/${id}`);
  },
};
